import { NASP_TRACKER_ACTIONS } from '../actions/naspTrackerActions';

// ─── HELPERS ──────────────────────────────────────────────────────────────────
const isSameData = (prev, next) =>
	JSON.stringify(prev) === JSON.stringify(next);

const toArray = (val) => (Array.isArray(val) ? val : []);

// ─── INITIAL STATE ─────────────────────────────────────────────────────────────
const initialState = {
	loading: {
		naspTracker:           false,
		naspTrackerById:       false,
		naspTrackerDropdowns:  false,
		naspTrackerHistory:    false,
		updateNaspTracker:     false,
		addNaspTrackerComment: false,
		exportNaspTracker:     false,
	},
	naspTracker:          [],
	naspTrackerById:      null,
	naspTrackerDropdowns: null,
	naspTrackerHistory:   [],
	activeUserFlag:       'All',
	error: null,
};

// ─── REDUCER ──────────────────────────────────────────────────────────────────
const NaspTrackerReducer = (state = initialState, action) => {
	switch (action.type) {

					// ── Get Nasp Tracker ──────────────────────────────────────────────────
					case NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_REQUEST:
						return {
							...state,
							loading: { ...state.loading, naspTracker: true },
							activeUserFlag: action.userFlag ?? state.activeUserFlag,
							error: null,
						};
					case NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_SUCCESS: {
						// ignore stale responses from a poll/request that no longer matches the active filter
						if (action.userFlag != null && action.userFlag !== state.activeUserFlag)
							return state;
						const next = toArray(action.payload?.naspTracker);
						if (isSameData(state.naspTracker, next))
							return { ...state, loading: { ...state.loading, naspTracker: false } };
						return { ...state, loading: { ...state.loading, naspTracker: false }, naspTracker: next, error: null };
					}
					case NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_FAILURE:
						return { ...state, loading: { ...state.loading, naspTracker: false }, error: action.error };

						// ── Get Nasp Tracker By Id ────────────────────────────────────────────
					case NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_BY_ID_REQUEST:
						return { ...state, loading: { ...state.loading, naspTrackerById: true }, error: null };
					case NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_BY_ID_SUCCESS:
						return { ...state, loading: { ...state.loading, naspTrackerById: false }, naspTrackerById: action.payload ?? null, error: null };
					case NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_BY_ID_FAILURE:
						return { ...state, loading: { ...state.loading, naspTrackerById: false }, error: action.error };

						// ── Get Nasp Tracker Dropdowns ─────────────────────────────────────────
					case NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_DROPDOWNS_REQUEST:
						return { ...state, loading: { ...state.loading, naspTrackerDropdowns: true }, error: null };
					case NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_DROPDOWNS_SUCCESS:
						return { ...state, loading: { ...state.loading, naspTrackerDropdowns: false }, naspTrackerDropdowns: action.payload ?? null, error: null };
					case NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_DROPDOWNS_FAILURE:
						return { ...state, loading: { ...state.loading, naspTrackerDropdowns: false }, error: action.error };

						// ── Get Nasp Tracker History ──────────────────────────────────────────
					case NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_HISTORY_REQUEST:
						return { ...state, loading: { ...state.loading, naspTrackerHistory: true }, error: null };
					case NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_HISTORY_SUCCESS: {
						const next = toArray(action.payload);
						if (isSameData(state.naspTrackerHistory, next))
							return { ...state, loading: { ...state.loading, naspTrackerHistory: false } };
						return { ...state, loading: { ...state.loading, naspTrackerHistory: false }, naspTrackerHistory: next, error: null };
					}
					case NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_HISTORY_FAILURE:
						return { ...state, loading: { ...state.loading, naspTrackerHistory: false }, error: action.error };

						// ── Update Nasp Tracker ───────────────────────────────────────────────
					case NASP_TRACKER_ACTIONS.NT_UPDATE_NASP_TRACKER_REQUEST:
						return { ...state, loading: { ...state.loading, updateNaspTracker: true }, error: null };
					case NASP_TRACKER_ACTIONS.NT_UPDATE_NASP_TRACKER_SUCCESS:
						return { ...state, loading: { ...state.loading, updateNaspTracker: false } };
					case NASP_TRACKER_ACTIONS.NT_UPDATE_NASP_TRACKER_FAILURE:
						return { ...state, loading: { ...state.loading, updateNaspTracker: false }, error: action.error };

						// ── Add Nasp Tracker Comment ──────────────────────────────────────────
					case NASP_TRACKER_ACTIONS.NT_ADD_NASP_TRACKER_COMMENT_REQUEST:
						return { ...state, loading: { ...state.loading, addNaspTrackerComment: true }, error: null };
					case NASP_TRACKER_ACTIONS.NT_ADD_NASP_TRACKER_COMMENT_SUCCESS:
						return { ...state, loading: { ...state.loading, addNaspTrackerComment: false } };
					case NASP_TRACKER_ACTIONS.NT_ADD_NASP_TRACKER_COMMENT_FAILURE:
						return { ...state, loading: { ...state.loading, addNaspTrackerComment: false }, error: action.error };

						// ── Export Nasp Tracker ───────────────────────────────────────────────
					case NASP_TRACKER_ACTIONS.NT_EXPORT_NASP_TRACKER_REQUEST:
						return { ...state, loading: { ...state.loading, exportNaspTracker: true }, error: null };
					case NASP_TRACKER_ACTIONS.NT_EXPORT_NASP_TRACKER_SUCCESS:
						return { ...state, loading: { ...state.loading, exportNaspTracker: false } };
					case NASP_TRACKER_ACTIONS.NT_EXPORT_NASP_TRACKER_FAILURE:
						return { ...state, loading: { ...state.loading, exportNaspTracker: false }, error: action.error };

					default:
						return state;
	}
};

export default NaspTrackerReducer;